import { render, staticRenderFns } from "./ShipDetailBanner.vue?vue&type=template&id=648e0421&scoped=true"
import script from "./ShipDetailBanner.vue?vue&type=script&lang=js"
export * from "./ShipDetailBanner.vue?vue&type=script&lang=js"
import style0 from "./ShipDetailBanner.vue?vue&type=style&index=0&id=648e0421&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648e0421",
  null
  
)

export default component.exports